var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.0087C7.02944 21.0087 3 17.1161 3 12.3144C3 9.27899 4.61019 6.60691 7.05044 5.05177M13.3635 3.71922C17.687 4.35399 21 7.96043 21 12.3144C21 15.4466 19.2855 18.1919 16.7136 19.7223M13.1255 5.9253L10.739 3.61988L13.1255 1.31445V5.9253ZM10.7381 18.7036L13.1246 21.009L10.7381 23.3145L10.7381 18.7036Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshare);
export default __webpack_public_path__ + "static/media/reshare.99a486d99b29ad5f41aa044c5f8896a6.svg";
export { ForwardRef as ReactComponent };